<template>
  <div class="page-container">
    <h1 class="page-title">{{ $t('contact') }}</h1>
    <p class="contact-intro text-secondary">{{ $t('contact_content') }}</p>
    <div class="contact-links">
      <component :is="contacts.github ? 'a' : 'div'" :href="contacts.github" :target="contacts.github ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.github }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.github"/></svg></span>
        <span class="contact-label">GitHub</span>
        <span class="contact-value" :class="{ empty: !contacts.github }">{{ contacts.github || $t('none') }}</span>
        <span v-if="contacts.github" class="contact-arrow">&rarr;</span>
      </component>
      <component :is="contacts.email ? 'a' : 'div'" :href="contacts.email ? 'mailto:'+contacts.email : undefined" class="contact-item" :class="{ link: !!contacts.email }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.email"/></svg></span>
        <span class="contact-label">Email</span>
        <span class="contact-value" :class="{ empty: !contacts.email }">{{ contacts.email || $t('none') }}</span>
        <span v-if="contacts.email" class="contact-arrow">&rarr;</span>
      </component>
      <div class="contact-item">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.wechat"/></svg></span>
        <span class="contact-label">WeChat</span>
        <span class="contact-value" :class="{ empty: !contacts.wechat }">{{ contacts.wechat || $t('none') }}</span>
      </div>
      <div class="contact-item">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.qq"/></svg></span>
        <span class="contact-label">QQ</span>
        <span class="contact-value" :class="{ empty: !contacts.qq }">{{ contacts.qq || $t('none') }}</span>
      </div>
      <div class="contact-item">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.qq"/></svg></span>
        <span class="contact-label">QQ Group</span>
        <span class="contact-value" :class="{ empty: !contacts.qq_group }">{{ contacts.qq_group || $t('none') }}</span>
      </div>
      <component :is="contacts.telegram ? 'a' : 'div'" :href="contacts.telegram" :target="contacts.telegram ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.telegram }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.telegram"/></svg></span>
        <span class="contact-label">Telegram</span>
        <span class="contact-value" :class="{ empty: !contacts.telegram }">{{ contacts.telegram || $t('none') }}</span>
        <span v-if="contacts.telegram" class="contact-arrow">&rarr;</span>
      </component>
      <component :is="contacts.x ? 'a' : 'div'" :href="contacts.x" :target="contacts.x ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.x }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.x"/></svg></span>
        <span class="contact-label">X (Twitter)</span>
        <span class="contact-value" :class="{ empty: !contacts.x }">{{ contacts.x || $t('none') }}</span>
        <span v-if="contacts.x" class="contact-arrow">&rarr;</span>
      </component>
      <div class="contact-item">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.phone"/></svg></span>
        <span class="contact-label">Phone</span>
        <span class="contact-value" :class="{ empty: !contacts.phone }">{{ contacts.phone || $t('none') }}</span>
      </div>
      <component :is="contacts.facebook ? 'a' : 'div'" :href="contacts.facebook" :target="contacts.facebook ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.facebook }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.facebook"/></svg></span>
        <span class="contact-label">Facebook</span>
        <span class="contact-value" :class="{ empty: !contacts.facebook }">{{ contacts.facebook || $t('none') }}</span>
        <span v-if="contacts.facebook" class="contact-arrow">&rarr;</span>
      </component>
      <div class="contact-item">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.instagram"/></svg></span>
        <span class="contact-label">Instagram</span>
        <span class="contact-value" :class="{ empty: !contacts.instagram }">{{ contacts.instagram || $t('none') }}</span>
      </div>
      <div class="contact-item">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.douyin"/></svg></span>
        <span class="contact-label">Douyin</span>
        <span class="contact-value" :class="{ empty: !contacts.douyin }">{{ contacts.douyin || $t('none') }}</span>
      </div>
      <component :is="contacts.tiktok ? 'a' : 'div'" :href="contacts.tiktok" :target="contacts.tiktok ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.tiktok }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.tiktok"/></svg></span>
        <span class="contact-label">TikTok</span>
        <span class="contact-value" :class="{ empty: !contacts.tiktok }">{{ contacts.tiktok || $t('none') }}</span>
        <span v-if="contacts.tiktok" class="contact-arrow">&rarr;</span>
      </component>
      <component :is="contacts.bilibili ? 'a' : 'div'" :href="contacts.bilibili" :target="contacts.bilibili ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.bilibili }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.bilibili"/></svg></span>
        <span class="contact-label">Bilibili</span>
        <span class="contact-value" :class="{ empty: !contacts.bilibili }">{{ contacts.bilibili || $t('none') }}</span>
        <span v-if="contacts.bilibili" class="contact-arrow">&rarr;</span>
      </component>
      <component :is="contacts.youtube ? 'a' : 'div'" :href="contacts.youtube" :target="contacts.youtube ? '_blank' : undefined" rel="noopener" class="contact-item" :class="{ link: !!contacts.youtube }">
        <span class="contact-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path :d="icons.youtube"/></svg></span>
        <span class="contact-label">YouTube</span>
        <span class="contact-value" :class="{ empty: !contacts.youtube }">{{ contacts.youtube || $t('none') }}</span>
        <span v-if="contacts.youtube" class="contact-arrow">&rarr;</span>
      </component>
    </div>
    <footer class="site-footer mt-4">
      <p class="text-tertiary text-xs">&copy; {{ year }} MARKJY &mdash; {{ $t('build_tool') }} Vue + Go</p>
    </footer>
  </div>
</template>

<script>
import { getContactsSettings } from '../api'
import {
  siGithub, siGmail, siWechat, siQq, siTelegram, siX,
  siFacebook, siInstagram, siTiktok, siBilibili, siYoutube
} from 'simple-icons'

export default {
  name: 'Contact',
  data() {
    return {
      contacts: {},
      icons: {
        github: siGithub.path,
        email: siGmail.path,
        wechat: siWechat.path,
        qq: siQq.path,
        telegram: siTelegram.path,
        x: siX.path,
        phone: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z',
        facebook: siFacebook.path,
        instagram: siInstagram.path,
        douyin: siTiktok.path,
        tiktok: siTiktok.path,
        bilibili: siBilibili.path,
        youtube: siYoutube.path
      }
    }
  },
  computed: { year() { return new Date().getFullYear() } },
  mounted() {
    getContactsSettings().then(res => {
      try { this.contacts = JSON.parse(res.data.data.contacts || '{}') } catch { this.contacts = {} }
    })
  }
}
</script>

<style scoped>
.page-title { font-size: 1.3rem; font-weight: 600; margin-bottom: 16px; }
.contact-intro { margin-bottom: 28px; line-height: 1.7; }
.contact-links { display: flex; flex-direction: column; gap: 2px; }
.contact-item { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid var(--border-light); color: var(--text-primary); text-decoration: none; }
.contact-item.link { transition: padding 0.2s ease; }
.contact-item.link:hover { padding-left: 6px; }
.contact-icon { flex-shrink: 0; width: 20px; height: 20px; display: flex; align-items: center; opacity: 0.55; }
.contact-icon svg { width: 100%; height: 100%; }
.contact-label { font-size: 0.9rem; width: 130px; flex-shrink: 0; }
.contact-value { font-size: 0.85rem; flex: 1; word-break: break-all; }
.contact-value.empty { color: var(--text-tertiary); }
.contact-arrow { color: var(--text-tertiary); font-size: 0.85rem; }
.site-footer { padding: 32px 0; text-align: center; }
</style>
